<template>
  <el-card>
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="120px">
      <el-row>
        <el-col :span="8">
          <el-form-item label="开票合同号：" prop="orderCode">
            {{dataForm.orderCode}}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="企业名称：" prop="companyName">
            {{dataForm.companyName}}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="税号：" prop="taxCode">
            {{dataForm.taxCode}}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="地址电话：" prop="address">
            {{dataForm.address}}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="银行：" prop="bank">
            {{dataForm.bank}}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="银行账号：" prop="accountCode">
            {{dataForm.accountCode}}
          </el-form-item>
        </el-col>
      </el-row>
      <div class="table-bar" >
        <div></div>
        <div style="font-size: 18px;color:#F56C6C;" >开票金额：{{totalPrice}}</div>
      </div>
      <el-table
          :data="dataForm.detailList"
          border
          style="width: 100%"
          :max-height="300"
      >
        <el-table-column
            type="index"
            header-align="center"
            align="center"
            width="50"
            label="行号"
        ></el-table-column>
        <el-table-column label="品番号"  prop="code" header-align="center" align="center"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="SKU"  prop="skuCode" header-align="center" align="center"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="品名"  align="center" prop="name" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
            label="颜色"
            prop="color"
            header-align="center"
            align="center"
            :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
            label="规格"
            prop="size"
            header-align="center"
            align="center"
            :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
            prop="count"
            label="数量"
            header-align="center"
            align="center"
        >

        </el-table-column>
        <el-table-column label="单价" prop="price" header-align="center" align="center">
        </el-table-column>
      </el-table>
    </el-form>
    <div class="card-foot" style="margin-top: 20px;">
      <el-button @click="cancel">返回</el-button>
    </div>
  </el-card>
</template>

<script>
import debounce from 'lodash/debounce'
import { isNumber, moneyValidator } from '@/utils/validate'
import BigNumber from 'bignumber.js'

export default {
  components: {  },
  data () {
    return {
      id: '',
      dataForm: {
        id: '',
        companyName: '',
        taxCode: '',
        address: '',
        bank: '',
        accountCode: '',
        amount: '',
        orderId: '',
        orderCode: '',
        detailList: []
      },
    }
  },
  computed: {
    totalPrice(){
      if(!this.dataForm||!this.dataForm.detailList||this.dataForm.detailList.length===0){
        return 0
      }
      let totalPrice=new BigNumber(0)
      this.dataForm.detailList.forEach(item=>{
        totalPrice=totalPrice.plus(new BigNumber(item.price).multipliedBy(item.count))
      })
      return totalPrice.toFixed(5)
    }
  },
  activated () {
    this.id=this.$route.query.id
    if(this.id){
      this.getInfo()
    }else{
      //从订单列表跳转携带参数,可能用不到
      this.dataForm.orderId=this.$route.query.orderId
      this.dataForm.orderCode=this.$route.query.orderCode
    }
  },
  methods: {
    // 获取信息
    getInfo () {
      this.$http.get(`/order/receipt/${this.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {
      })
    },
    cancel () {
      this.$router.back()
    }
  }
}
</script>
